import React, { useEffect, useRef, useState } from 'react';

export default function CategoryFilter({ categories, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setSearch('');
      }
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  function toggle(cat) {
    onChange(selected.includes(cat) ? selected.filter((c) => c !== cat) : [...selected, cat]);
  }

  const label =
    selected.length === 0
      ? 'All categories'
      : selected.length === 1
      ? selected[0]
      : `${selected.length} categories`;

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          padding: '0 10px',
          height: 36,
          width: 180,
          border: '1px solid var(--border)',
          borderRadius: 6,
          background: selected.length ? 'var(--green-light)' : '#fff',
          cursor: 'pointer',
          fontSize: 13,
          color: selected.length ? 'var(--green)' : 'inherit',
          fontWeight: selected.length ? 600 : 400,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, textAlign: 'left' }}>
          {label}
        </span>
        <i className={`ti ti-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: 12, flexShrink: 0 }} />
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            zIndex: 200,
            background: '#fff',
            border: '1px solid var(--border)',
            borderRadius: 6,
            boxShadow: '0 4px 16px rgba(0,0,0,.12)',
            width: 200,
            maxHeight: 280,
            overflowY: 'auto',
          }}
        >
          <div style={{ padding: '6px 8px', borderBottom: '1px solid var(--border)' }}>
            <input
              autoFocus
              placeholder="Search categories…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onMouseDown={(e) => e.stopPropagation()}
              style={{ width: '100%', fontSize: 12, padding: '4px 8px', boxSizing: 'border-box' }}
            />
          </div>
          {(() => {
            const visible = categories.filter((c) =>
              c.toLowerCase().includes(search.trim().toLowerCase())
            );
            return visible.length === 0 ? (
              <div style={{ padding: '8px 12px', fontSize: 12, color: 'var(--text2)' }}>No matches</div>
            ) : (
              <>
                {selected.length > 0 && !search && (
                <div
                  onMouseDown={(e) => { e.preventDefault(); onChange([]); }}
                  style={{
                    padding: '6px 12px',
                    fontSize: 11,
                    color: 'var(--green)',
                    fontWeight: 600,
                    borderBottom: '1px solid var(--border)',
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                >
                  Clear selection
                </div>
              )}
                {visible.map((cat) => (
                  <label
                    key={cat}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '8px 12px',
                      cursor: 'pointer',
                      fontSize: 13,
                      borderBottom: '1px solid #f5f5f5',
                      background: selected.includes(cat) ? 'var(--green-light)' : '#fff',
                      userSelect: 'none',
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selected.includes(cat)}
                      onChange={() => toggle(cat)}
                      style={{ cursor: 'pointer', accentColor: 'var(--green)', flexShrink: 0, width: 14, height: 14 }}
                    />
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{cat}</span>
                  </label>
                ))}
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
}
